import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

function Inscription2() {
  return (
    <>
    <Row xs={1} md={2} className="g-4" style={{width:"95%"}}>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/arbitre.jpg" />
            <Card.Body>
              <Card.Title>Rejoignez notre equipe d'Arbitres !</Card.Title>
              <Card.Text>
              En vous inscrivant, vous aurez l'opportunité de contribuer au développement du sport que vous 
              aimez.
              </Card.Text>
              <Link to="/inscription/arbitre">
                <Button className="custom-btn" variant="primary" >S'inscrire</Button>
                </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/coach.avif" />
            <Card.Body>
              <Card.Title>Inscrivez votre equipe aujourd'hui !</Card.Title>
              <Card.Text>
              En inscrivant votre équipe, vous ouvrez la porte à une multitude d'opportunités et d'avantages uniques.

              </Card.Text>
              <Link to="/inscription/equipe">
                    <Button  className="custom-btn" variant="primary" >S'inscrire</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
    </Row>
  

    </>
  );
}

export default Inscription2;